<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!resellerPayment">
      <span class="loader"></span>
    </span>
    <reseller-payment-form
      v-if="resellerPayment"
      :loading="loading"
      :resellerPaymentData="resellerPayment"
      :formErrors="formErrors"
      @resellerPaymentSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import ResellerPaymentForm from "../partials/ResellerPaymentForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultResellerPayment from "../defaultResellerPayment";

export default {
  layout: "DashboardLayout",

  components: { ResellerPaymentForm },

  mixins: [alertLeave],

  props: {
    resellerPaymentId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      resellerPayment: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "resellerPayments/get",
          this.resellerPaymentId
        );
        this.resellerPayment =
          this.$store.getters["resellerPayments/resellerPayment"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(resellerPayment) {
      this.loading = true;
      const resellerPaymentData = cloneDeep(resellerPayment);

      try {
        await this.$store.dispatch(
          "resellerPayments/update",
          resellerPaymentData
        );
        this.$notify({
          type: "success",
          message: this.$t("RESELLER_PAYMENTS.RESELLER_PAYMENTS_UPDATED"),
        });
        const resellerPayment = await this.$store.getters[
          "resellerPayments/resellerPayment"
        ];
        this.$emit("onViewResellerPayment", resellerPayment, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
